import _ from 'lodash'
import { ValidateUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import { PRODUCT_VOLUME_MAP } from '@vzmi/shp_shared_compo/constants/proposal'
import { isNumberOrNumberString } from './Validator'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'

/**
 * value 是有效的數字或數字字串的話，加 .00 後存入 redux-form state
 * value 非有效數字，直接存入 redux-form state，後續由 validate, format 處理
 * */
export const parsePriceWithFixedDigits = (value = 0, option = {}) => {
  const { digits = 2 } = option

  value = _.trim(value)
  if (value === '') { return null }
  if (isNumberOrNumberString(value)) {
    return _.toNumber(value).toFixed(digits)
  }

  return value
}

/**
 * 商品材積的輸入值，
 * 在去掉 '長寬高' 後，
 * 是數字的轉 number 存到 state
 * 不是數字的維持 string 存到 state
 * */
export const productSizeFieldsParser = (value = '', name) => {
  const dimensionLabels = _.values(PRODUCT_VOLUME_MAP).join('')
  const reg = new RegExp(`[${dimensionLabels}]`, 'g')
  const valueWithoutLabel = value.replace(reg, '')
  const trimmedValue = ValidateUtil.removeSpaceAndNewline(valueWithoutLabel)
  return isNumberOrNumberString(trimmedValue)
    ? _.toNumber(trimmedValue)
    : trimmedValue
}

// regular expression to remove all non-printable characters：
// https://stackoverflow.com/a/14568679

/**
 * regular expression to remove all non-printable characters.
 * @see https://stackoverflow.com/a/14568679
 *
 * remove all control characters, except
 * \t [Ctrl] I  9 09   HT
 * \n [Ctrl] J  10  0A   LF
 * \r [Ctrl] M  13  0D   CR
 * @see http://ascii-table.com/control-chars.php
 */
/* eslint-disable-next-line no-control-regex */
export const removeNonPrintableCharParser = (value) => _.isString(value) ? value.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '') : value

/**
 * the start and end of a string must be valid char
 */
/* eslint-disable-next-line no-control-regex */
export const removeInvalidStartEnd = value => _.isString(value) ? value.replace(/^\s+|\s+$/g, '') : value

/**
 * 只保留數字與逗號
 */
export const removeNotNumberAndComma = value => {
  const replacedText = _.flow(
    _.toString,
    // 逗號取代換行符號
    text => _.replace(text, /\r?\n|\r| /g, COMMA),
    // 移除數字與逗號外的字元
    textWithComma => _.replace(textWithComma, /\D+/g, str => {
      return _.replace(str, /[^,]/g, '')
    }),
    // 單個逗號取代多個逗號
    textWithCommas => _.replace(textWithCommas, /,+/g, COMMA),
    // 如果開頭是逗號則移除
    textWithComma => _.replace(textWithComma, /^,/, '')
  )(value)
  return replacedText
}

/**
 *
 * parse the String period from API to an Object containing start and end
 *
 * @example
 * "2037-12-02T16:00:00Z/2038-01-01T15:59:59Z"
 * will be
 * {
 *  "start": "2037-12-02T16:00:00Z",
 *  "end": "2038-01-01T15:59:59Z"
 * }
 *
 */
export const periodSegmentParser = (period = null) => {
  if (_.isEmpty(period)) {
    return null
  }
  const periods = period.split('/')
  const start = _.first(periods, '')
  const end = _.get(periods, '[1]', '')
  return {
    start,
    end
  }
}

/**
 * 移除部分字串
 * ref:https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 */
export const partialRemovedStringParser = (listingData, inputData) => {
  // 將所有特殊字元用反斜線轉義，以避免在搜尋和替換時出現意外的結果，並用全局搜索標誌 g 來匹配
  const regex = new RegExp(inputData.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
  return listingData.replace(regex, '')
}

/**
 * 保留英數字與逗號（用於賣場編號輸入）
 * 支援英文開頭的賣場編號格式
 */
export const removeNotAlphanumericAndComma = value => {
  const replacedText = _.flow(
    _.toString,
    // 逗號取代換行符號和空格
    text => _.replace(text, /\r?\n|\r| /g, COMMA),
    // 移除英數字與逗號外的字元
    textWithComma => _.replace(textWithComma, /[^a-zA-Z0-9,]/g, ''),
    // 單個逗號取代多個逗號
    textWithCommas => _.replace(textWithCommas, /,+/g, COMMA),
    // 如果開頭是逗號則移除
    textWithComma => _.replace(textWithComma, /^,/, '')
  )(value)
  return replacedText
}
